exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge[data-v-e6ac0ae6]{display:inline-flex;padding:.3rem .5rem;background-color:#c9c9c9;color:#fff;border-radius:1rem;transition-property:background-color,border-color,color,fill,stroke,opacity,box-shadow,transform;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s;font-size:.9rem;margin:0 .2rem;cursor:pointer}.bg-primary[data-v-e6ac0ae6]{background-color:#32cc99}.bg-green[data-v-e6ac0ae6]{background-color:#67c23a}.bg-red[data-v-e6ac0ae6]{background-color:#f56c6c}.bg-blue[data-v-e6ac0ae6]{background-color:#2b57a3}.bg-primary-hover[data-v-e6ac0ae6]:hover{background-color:#32cc99}.bg-green-hover[data-v-e6ac0ae6]:hover{background-color:#67c23a}.bg-red-hover[data-v-e6ac0ae6]:hover{background-color:#f56c6c}.bg-blue-hover[data-v-e6ac0ae6]:hover{background-color:#2b57a3}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e6ac0ae6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/badge.vue
// module id = 559
// module chunks = 0